<template>
<!-- 退保详情 -->
  <div class="page">
    <div>
      <div
        style="
          background-color: #0065b3;
          color: #fff;
          font-size: 18px;
          padding: 6px 20px;
          font-weight: bold;
        "
      >
        &nbsp;&nbsp;申请发票
      </div>
      <div
        style="
          background-color: #f2f2f2;
          color: #73756f;
          font-size: 18px;
          padding: 6px 20px;
          display:flex;
        "
      >
        <div 
          style="
            background-color: #0065b3;
            height:18px;
            width:8px;
            margin-top:2px;
        "></div>&nbsp;&nbsp;订单信息
      </div>
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item
          label="营业执照"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >
        {{this.form}}
        </el-descriptions-item>
        <el-descriptions-item
          label="社会统一信用代码"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
        <el-descriptions-item
          label="企业名称"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
        <el-descriptions-item
          label="法人姓名"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
      </el-descriptions>
      <div
        style="
          background-color: #f2f2f2;
          color: #73756f;
          font-size: 18px;
          padding: 6px 20px;
          display:flex;
        "
      >
        <div 
          style="
            background-color: #0065b3;
            height:18px;
            width:8px;
            margin-top:2px;
        "></div>&nbsp;&nbsp;订单信息
      </div>
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item
          label="营业执照"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >
        {{this.form}}
        </el-descriptions-item>
        <el-descriptions-item
          label="社会统一信用代码"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
        <el-descriptions-item
          label="企业名称"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
        <el-descriptions-item
          label="法人姓名"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
      </el-descriptions>
      <div
        style="
          background-color: #0065b3;
          color: #fff;
          font-size: 18px;
          padding: 6px 20px;
          font-weight: bold;
        "
      >
        &nbsp;&nbsp;申请发票
      </div>
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item
          label="营业执照"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >
        {{this.form}}
        </el-descriptions-item>
        <el-descriptions-item
          label="社会统一信用代码"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
        <el-descriptions-item
          label="企业名称"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
        <el-descriptions-item
          label="法人姓名"
          :labelStyle="{'text-align': 'right', 'width' : '200px'}"
          :contentStyle="{'width': '400px'}"
        >{{this.form}}</el-descriptions-item>
      </el-descriptions>
    </div>
    
    
    
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      form:{}
    }
  },
  methods:{

  },
  components: {

  }
}
</script>

<style scoped>
.page {
  background-color: #fff;
  height: 100%;
  margin: 0 20px;
}
.elCard {
  background-color: #0065b3 !important;
  color: #fff;
}
</style>
